import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default theme => ({
  root: {},
  search: {
    width: '100%'
  },
  searchWithSelectors: {
    width: 150,
    display: 'flex',
    flexGrow: 1
  },
  multipleSelectors: {
    display: 'flex',
    justify: 'space-between',
    gap: 8,
    alignItems: 'center',
    '& input[type="text"]': {
      height: 30
    }
  },
  popoverCustomWide: {
    '& .hoi-poi-popover-inner': {
      width: 320
    },
    '& .hoi-poi-select__menu': {
      boxShadow: 'none !important',
      paddingBottom: 0,
      margin: 0
    }
  },
  overlay: {
    zIndex: 1601
  },
  optionsContainer: {
    padding: '4px 16px',
    minHeight: 'calc(100% -40px)'
  },
  group: {},
  groupTitle: {
    height: 32,
    display: 'flex',
    alignItems: 'center',
    color: theme.colors.utility.textPrimary
  },
  groupSection: {
    '& [class*="Icon"]': {
      width: '18px !important',
      height: '18px !important'
    },
    '& [class*="groupTitle"] [class*="optionText"]': {
      color: theme.colors.utility.textSecondary
    }
  },
  groupSectionDisabled: {
    display: 'none'
  },
  groupSectionContent: {
    display: 'none',
    overflow: 'hidden',
    transition: 'height .4s ease'
  },
  groupSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
    cursor: 'pointer'
  },
  groupSectionHeading: {
    display: 'flex'
  },
  groupSectionCount: _objectSpread(_objectSpread({}, theme.typography.defaultText), {}, {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 20 / 14,
    color: theme.colors.utility.textSecondary,
    marginLeft: 4
  }),
  groupSectionTitle: _objectSpread(_objectSpread({}, theme.typography.defaultText), {}, {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 20 / 14,
    color: theme.colors.utility.textPrimary
  }),
  optionContainer: {
    paddingLeft: '24px'
  },
  option: {
    height: 36,
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  optionText: {
    paddingLeft: '8px',
    color: theme.colors.utility.textPrimary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  optionComment: {
    paddingLeft: '8px',
    color: theme.colors.grey[500],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  advice: {
    marginBottom: '8px'
  },
  resetSelected: {
    color: theme.colors.actionMajor[500],
    '&:hover': {
      color: theme.colors.actionMajor[600]
    }
  },
  resetSelectedDisabled: {
    color: theme.colors.actionMajor[150],
    '&:hover': {
      color: theme.colors.actionMajor[150]
    },
    cursor: 'default !important'
  },
  loader: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  searchInput: {
    '& [class*="Input__input"]::placeholder': {
      color: theme.colors.textLight.primary
    },
    '& [class*="Input__inputComponents"]': {
      backgroundColor: 'transparent',
      borderRadius: 0,
      borderBottom: `1px solid ${theme.colors.grey[800]}`
    },
    '&[class*="Input__focused"]': {
      '& [class*="Input__inputComponents"]': {
        backgroundColor: theme.colors.actionMinor[50],
        borderColor: 'transparent !important',
        borderBottom: `1px solid ${theme.colors.grey[800]} !important`
      }
    }
  }
});